import { LanguageInfo } from "../../common/StrongFB-interfaces";

export const FA_LANG_INFO: LanguageInfo = {
    latin: 'Farsi',
    code: 'fa',
    direction: 'rtl',
    native: 'فارسی',
    defaultFontName: 'vazir',
    dateFormat: 'ddd D MMMM',
    calendar: 'jalali',
};